var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 114,
  height: 52,
  fill: "none",
  viewBox: "0 0 114 52"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1E82F0",
  d: "M62.933 15.51a7.782 7.782 0 1 1-13.477-7.782 7.782 7.782 0 0 1 13.477 7.782"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E82F0",
  d: "M45.265 21.782a4.67 4.67 0 1 1-8.088-4.67 4.67 4.67 0 0 1 8.088 4.67"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#253044",
  d: "M16.142 43.43q-.904 1.49-2.662 2.377-1.76.887-4.263.887-3.772 0-6.212-1.838Q.564 43.02.343 39.722H6.11q.126 1.267.903 1.997.777.729 1.98.729 1.046 0 1.65-.571.6-.57.601-1.521 0-.855-.554-1.427-.555-.57-1.379-.934a32 32 0 0 0-2.282-.872q-2.124-.728-3.47-1.41-1.348-.681-2.314-2.029-.967-1.346-.967-3.502 0-1.996 1.014-3.454t2.805-2.235 4.105-.776q3.74 0 5.942 1.775t2.488 4.88H10.77q-.159-1.109-.808-1.759-.65-.649-1.76-.65-.95 0-1.536.508-.588.507-.587 1.49 0 .792.523 1.346.523.555 1.315.904.792.348 2.282.887 2.156.73 3.518 1.442 1.363.714 2.345 2.076t.983 3.55a6.2 6.2 0 0 1-.903 3.264"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#253044",
  d: "m30.54 46.473-5.293-7.512v7.512h-5.42V23.708h5.42v12.18l5.293-7.1h6.37l-7.13 8.842 7.29 8.843z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#253044",
  d: "M43.93 28.788v17.685h-5.42V28.788z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#253044",
  d: "M62.205 29.66q1.727 1.092 2.725 3.137.999 2.044.999 4.833 0 2.757-.999 4.818-.998 2.06-2.726 3.153t-3.914 1.093q-2.028 0-3.486-.919a5.33 5.33 0 0 1-2.123-2.503v8.62h-5.42V28.788h5.42v3.2a5.34 5.34 0 0 1 2.123-2.503q1.458-.92 3.486-.92 2.187 0 3.915 1.094m-8.463 4.816q-1.093 1.158-1.093 3.154 0 1.965 1.093 3.138 1.094 1.173 2.805 1.172 1.743 0 2.805-1.14 1.062-1.141 1.062-3.17t-1.062-3.17q-1.062-1.14-2.805-1.14-1.712 0-2.805 1.156"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E82F0",
  d: "M110.33 35.019c-6.446 11.165-20.723 14.99-31.888 8.544s-14.99-20.722-8.544-31.887S90.62-3.314 101.785 3.13c11.166 6.446 14.991 20.723 8.545 31.888"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M77.127 24.668v4.537h-3.128V16.27h5.067q2.305 0 3.513 1.144t1.207 3.082q0 1.208-.54 2.15t-1.6 1.482q-1.062.54-2.58.54zm3.476-4.172q0-1.701-1.884-1.701h-1.592v3.366h1.592q1.883 0 1.884-1.665"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M90.816 19.399q.84.53 1.244 1.445v-1.848h3.11v10.209h-3.11v-1.848a3.2 3.2 0 0 1-1.244 1.445q-.842.53-2.013.53-1.261 0-2.259-.63-.998-.632-1.573-1.82-.577-1.19-.577-2.781 0-1.611.577-2.79.576-1.18 1.573-1.811.997-.632 2.26-.632 1.17 0 2.012.53M88.19 22.27q-.614.66-.613 1.83 0 1.17.613 1.829.612.659 1.619.659.987 0 1.619-.677.63-.677.63-1.811 0-1.153-.63-1.82-.63-.669-1.62-.668-1.005 0-1.618.658"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M107.857 18.996H104.4l-2.287 6.257-2.452-6.257h-3.494l4.281 9.825-1.596 3.497h3.379z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h114v52H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.28 0h113.365v52H.28z"
})))));
export default SvgLogo;